import React from 'react'
import MendMappingForm from './MendMappingForm';
import MendCredentialsForm from './MendCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function MendConfigListing(props) {

    const columns = []

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={MendMappingForm}
            CredentialsForm={MendCredentialsForm}
            extraColumns={columns}
            componentName="Project"
            componentKey="projectName"
        />
    )
}